var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"pt-3"},[_c('footer-top'),_c('footer-back-to-top'),_c('footer-bottom-vue')],1)}
var staticRenderFns = []

export { render, staticRenderFns }